import { getRole, getRoles } from "_graphql/kek/queries/roles.kek";

import { User_role } from "_graphql/queries/kek/__generated__/User_role";
import { User_roles } from "_graphql/queries/kek/__generated__/User_roles";
import { useQuery } from "@apollo/client";

export const useRoles = () => {
    const { data, ...rest } = useQuery<User_roles>(getRoles);
    return {
        roles: data?.user_roles || [],
        ...rest,
    };
};

export const useRole = (userRoleId: string) => {
    const { data, ...rest } = useQuery<User_role>(getRole, {
        variables: { userRoleId },
    });
    return {
        role: data?.user_role || null,
        ...rest,
    };
};
